import { IstatGenerationParameters } from '@h5s/entities';

export class GenerationParameters extends IstatGenerationParameters {
  openDays: number | null;
}
